import request from ".";

export const contactAyana = async (mailValues) => {
  const response = await request.post("/api/v1/support/mail_to_ayana.json", {
    support_info: mailValues,
  });
  return response;
};
